import { Component, Input } from "@angular/core";
import { UserRecentEquipment } from "@core/interfaces/users-recent-equipment.interface";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "astrobin-post-equipment-header",
  templateUrl: "./post-equipment-header.component.html",
  styleUrls: ["./post-equipment-header.component.scss"]
})
export class PostEquipmentHeaderComponent {
  @Input() equipment: UserRecentEquipment;

  constructor(public readonly translateService: TranslateService) {}

  getEquipmentLink(klass: string, id: number): string {
    return `/equipment/explorer/${klass.toLowerCase()}/${id}`;
  }

  hasAnyEquipment(): boolean {
    return !!(this.equipment?.telescope || this.equipment?.camera || this.equipment?.mount);
  }
}
